import {useQuery} from 'react-query';

import UserApiService from '@/modules/admin/services/UserApiService';
import {CACHE_KEY_LIST_MY_PROPOSAL_REQUEST} from '@/modules/proposalRequest/contants/myProposalRequest';

const useGetUserProposals = (id, config = {}) => {
  return useQuery([CACHE_KEY_LIST_MY_PROPOSAL_REQUEST, id, 'user-proposals'], async () => {
    const {data} = await UserApiService.getUserProposals(id);
    return (data);
  }, {enabled: !!id, ...config, refetchOnWindowFocus: false});
};

export default useGetUserProposals;
